import React from 'react';
import dateFormat from 'dateformat';
import { IReceiptData } from '../../../../ApiCalls';
import CalendarDays from '../../icons/CalendarDays';

import Empty from '../../icons/Empty';
import { ReduxUpdater } from '../../../../redux/ReduxUpdater';
import { GlobalVariables } from '../../../../GlobalVariables';

export interface IDateTimeInputProps {
    label: string;
    receipt: IReceiptData;
    type: 'edit' | 'locked' | 'warning';
    width?: string;
    onUpdate?: (newDate: string) => void;
}

export const formatStringDate = (strDate: string | null) => {
    console.log('formatStringDate', strDate);
    if (!strDate || strDate === '') {
        return '';
    }
    const [y, m, d] = strDate.split("-").map(Number);
    const localDate = new Date(y, m - 1, d); // local date, no UTC shift
    return formatDate(localDate);
}

export const formatDate = (date: Date, withYear = false) => {
    // 'ddd, d. mmm yyyy'
    return dateFormat(date, `ddd, d. mmm${withYear ? ' yyyy' : ''}`);
}

export const formatReceiptDate = (date: Date) => {
    // 'yyyy-mm-dd'
    return dateFormat(date, 'yyyy-mm-dd');
}

export const formatReimbursementDate = (date: Date) => {
    // 'yyyy-mm-dd'
    return dateFormat(date, 'mm-dd');
}

const formatTime = (strTime: string | null) => {
    if (!strTime) {
        return '';
    }
    const now = new Date();
    return dateFormat(new Date(now.toDateString() + ' ' + strTime), 'HH:MM') + 'h';
}

const DateTimeInput = (props: IDateTimeInputProps) => {
    const { label, receipt, type, width, onUpdate } = props;

    return (
        <div className={`self-stretch flex flex-col justify-center items-start gap-2 text-text-dark `}>
            <div className="Textinputtitle self-stretch justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">{label}</div>
            <div
                className={`w-${width ?? 'full'} h-10 px-4 py-3 bg-bg-input-${type} rounded-lg outline outline-1 outline-offset-[-0.50px] border-border-default inline-flex justify-start items-center gap-2.5 overflow-hidden`}
            >
                <div className="Lefttext justify-center text-text-dark text-base font-normal font-['Inter'] leading-none">{formatStringDate(receipt.transaction_date)}</div>
                <div className="flex-1 flex justify-end items-center gap-2.5">
                    <div className="Righttext text-right justify-start text-text-dark text-base font-normal font-['Inter'] leading-none">{formatTime(receipt.transaction_time)}</div>
                </div>
                <div className="self-stretch py-2.5 flex justify-end items-center overflow-hidden">
                    <div className="relative">
                        {type==='locked'
                            ? <Empty {...{ height: '15px' }} />
                            : <button onClick={() => {
                                GlobalVariables.dialogConfig.onClickDate = (s) => {
                                    console.log('datepicked:', s.context.selectedDates);
                                    if (s.context.selectedDates.length > 0 && onUpdate) {
                                        console.log(s.context.selectedDates[0]);
                                        onUpdate(s.context.selectedDates[0]);
                                        ReduxUpdater.currentDialog = null;
                                    }
                                };
                                GlobalVariables.dialogConfig.selectedDates = receipt.transaction_date ? [receipt.transaction_date] : undefined;
                                ReduxUpdater.currentDialog = 'datePicker';
                            }}>
                                <CalendarDays {...{ height: '15px' }} />
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DateTimeInput;